<template>
  <!-- Conteudo-->
  <router-view />
  <!-- /Conteudo-->
</template>

<script>
require('@/assets/vendor/bootstrap/css/bootstrap.min.css')
require('@/assets/vendor/font-awesome/css/font-awesome.min.css')
require('@/assets/vendor/datatables/dataTables.bootstrap4.css')
require('@/assets/css/admin.css')
require('@/assets/css/custom.css')
export default {
  data() {
    return {
    };
  },
}
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');
html {
  scroll-behavior: smooth;
  box-sizing: border-box;
}
body {
  margin: 0;
}
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>